export default __webpack_public_path__ + "static/media/Banner - AirDockz - White.d9c5bb46.jpg";